import { render, staticRenderFns } from "./Forum.vue?vue&type=template&id=f0556a90&scoped=true"
import script from "./Forum.vue?vue&type=script&lang=js"
export * from "./Forum.vue?vue&type=script&lang=js"
import style0 from "./Forum.vue?vue&type=style&index=0&id=f0556a90&prod&scoped=true&lang=css"
import style1 from "./Forum.vue?vue&type=style&index=1&id=f0556a90&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0556a90",
  null
  
)

/* custom blocks */
import block0 from "./Forum.vue?vue&type=custom&index=0&blockType=el-dialog&title=%E7%BC%96%E8%BE%91%E5%B8%96%E5%AD%90&%3Avisible.sync=editDialogVisible&width=600px&%3Aclose-on-click-modal=false&%40close=cancelEdit"
if (typeof block0 === 'function') block0(component)

export default component.exports